module.exports = __webpack_public_path__ + "img/konsultasi@2x.370f892e.png";